import React, { useEffect } from 'react';
import { useAppSelector } from '@src/core/hooks';
import { LayoutColors } from '@src/core/theme';
import { BodySmallMedium } from '@src/fonts/typography/Typography';
import styled from 'styled-components';
import useTranslate from '../../../i18n/useTranslate';
import { getErrorMessage } from '../../../common/index';
import { errorsSelector, loadTerms, setCurrentTerms } from '@src/features/auth';
import { InputArea, InputAttribute, InputLabel } from '../StyledComponents/InputStyled';
import { useAppDispatch } from '../../../core/hooks';

export const TERMS_OF_USE = 'terms_of_use';
export const PRIVACY_POLICY = 'privacy_policy';

interface InputCheckboxTermsAndPolicyProps {
  errorContext: string;
  name: string;
}
export const InputCheckboxTermsAndPolicy = ({ errorContext, name }: InputCheckboxTermsAndPolicyProps) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslate();
  const errors = useAppSelector(errorsSelector);
  const errorMessage = getErrorMessage(errors[errorContext], name);

  useEffect(() => {
    dispatch(loadTerms());
  }, []);

  return (
    <InputArea>
      <InputAreaCheckbox>
        <InputAttribute
          errorContext={errorContext}
          name={name}
          id={name}
          type='checkbox'
          $issetError={!!errorMessage}
        ></InputAttribute>
        <InputLabel htmlFor={name}>
          <InfoTerms>
            {i18n('auth_termsRead')}
            <ButtonModal onClick={() => dispatch(setCurrentTerms(TERMS_OF_USE))}>{i18n('auth_terms')}</ButtonModal>
            {i18n('auth_termsAnd')}
            <ButtonModal onClick={() => dispatch(setCurrentTerms(PRIVACY_POLICY))}>{i18n('auth_policy')}</ButtonModal>
          </InfoTerms>
        </InputLabel>
      </InputAreaCheckbox>
      {errorMessage && <CheckboxValidation> {i18n('auth_requiredCheckOfTermsAndPrivacyPolicy')} </CheckboxValidation>}
    </InputArea>
  );
};

const InfoTerms = styled.span``;

const ButtonModal = styled.span`
  font-weight: bold;
  cursor: pointer;
`;

const InputAreaCheckbox = styled.div`
  display: inline-flex;
  gap: 8px;
  label {
    display: contents;
  }
  input {
    &[type='checkbox'] {
      width: 15px;
    }
  }
`;

const CheckboxValidation = styled.div`
  ${BodySmallMedium};
  text-align: center;
  padding: 8px;
  background-color: ${LayoutColors.errorLight};
  color: ${LayoutColors.errorDark};
  border-radius: 4px;
  width: fit-content;
`;

export default InputCheckboxTermsAndPolicy;
